import { Embed, Image, Quote, Text, Video } from '..';

export type MapperProps = {
  block: any;
  id?: any;
  [key: string]: any;
};

export const Mapper = ({ block, id, ...rest }: MapperProps) => {
  const map = {
    embed: Embed,
    image: Image,
    quote: Quote,
    text: Text,
    video: Video,
  };

  if (!map.hasOwnProperty(block.type)) return null;
  const Component = map[block.type.toLowerCase() as keyof typeof map];
  return <Component {...block} id={id} {...rest} />;
};

Mapper.defaultProps = {
  block: {},
} as Partial<MapperProps>;
